import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import useAuth from "../Hooks/useAuth";
import useLogout from "../Hooks/useLogout";
import SideBar from "./SideBar";
import logo from "../Images/logo.png"
import useAxiosPrivate from "../Hooks/useAxiosPrivate";

const Navbar = () => {
  const { auth } = useAuth();
  const axiosPrivate = useAxiosPrivate();
  const logout = useLogout();
  const navigate = useNavigate();
  const [count, setCount] = useState();

  useEffect(() => {
    const notificationCount = async () => {
      try {
        const response = await axiosPrivate.get("notification/count/");
        setCount(response?.data)
      } catch (err) {
        console.log('err')
      }
    }
    notificationCount();
  }, [auth])

  async function onLogout() {
    await logout();
    navigate("/login");
  }
  return (
    <div>
      <nav className="navbar navbar-expand-lg bg-light">
        <div className="container-fluid">
          <a className="navbar-brand mx-4" href="#">
            <img src={logo} style={{height: 2 + 'rem'}} alt="Doctor" />
          </a>
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <p className="m-0 navbar-toggler-icon"></p>
          </button>
          <div className="collapse navbar-collapse" id="navbarSupportedContent">
            <ul className="navbar-nav me-auto mb-2 mx-3 mb-lg-0 justify-content-end w-100">
              <li className="nav-item mx-4">
                <a className="nav-link" aria-current="page" href="/">
                  Home
                </a>
              </li>
              {(auth?.user?.roles === 2 || !auth?.user ) &&<li className="nav-item mx-4">
                <a className="nav-link" href="/doctor">
                  Book Appointment
                </a>
              </li>}
              <li className="nav-item mx-4">
                <a className="nav-link " href="/blogs">
                  Blogs
                </a>
              </li>
              <li className="nav-item mx-4">
                <a className="nav-link " href="/about">
                  About Us
                </a>
              </li>
              <li className="nav-item mx-4">
                <a className="nav-link" href="/contact">
                  Contact
                </a>
              </li>
              {!auth?.accessToken ? (
                <li className="nav-item mx-4">
                  <a className="nav-link" href="/login">
                    Login
                  </a>
                </li>
              ) : (
                <li
                  className="nav-item mx-4 dropdown text-capitalize"
                  style={{ paddingRight: 3 + "rem" }}
                >
                  <a
                    className="nav-link dropdown-toggle"
                    href="#"
                    role="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    {auth?.user.roles===1 && "Dr. "}{auth?.user["name"].split(" ")[0]}
                    <i className="mx-2 fa-solid fa-bell text-primary"><label className="text-danger p-0 m-0 position-absolute top-25">{count}</label></i>
                  </a>
                  <ul className="dropdown-menu" style={{zIndex:1300}}>
                    <li
                      data-bs-toggle="offcanvas"
                      data-bs-target="#offcanvasNavbar"
                      aria-controls="offcanvasNavbar"
                    >
                      <a className="dropdown-item" href="#">
                        Profile
                      </a>
                    </li>
                    <li>
                      <a className="dropdown-item" href="/notification">
                        Notification <label className="text-white border rounded-circle py-1 px-2 m-0 bg-primary">{count}</label>
                      </a>
                    </li>
                    <li>
                      <a className="dropdown-item" onClick={onLogout}>
                        Logout
                      </a>
                    </li>
                  </ul>
                </li>
              )}
            </ul>
          </div>
        </div>
      </nav>
      <SideBar />
    </div>
  );
};

export default Navbar;
